import { bindAnimationFrame } from '../../../utils';

export default class TriggerHandlerBase {
  constructor(ctx, nodeService, typeKey) {
    const { store, $tracking } = ctx;
    this.store = store;
    this.nodeService = nodeService;
    this.tracking = $tracking;
    this.typeKey = typeKey;
    this.isInitiated = false;

    // Binding the start conversation method to the requestAnimationFrame to reduce layout thrashing
    this.startConversation = bindAnimationFrame(this.startAmpConversation);
  }

  getTriggers() {
    return (
      this.store.getters['chatbotStore/getTriggers']
        ?.filter((trigger) => !!trigger[this.typeKey])
        .map((trigger) => trigger) ?? []
    );
  }

  startAmpConversation(trigger) {
    const { id, conversationId, onEachEncounter, compactNudge, compactNudgeMessage } = trigger;
    const wasTriggered = this.store.getters['chatbotStore/wasTriggered'](id);

    if (wasTriggered && !onEachEncounter) {
      return;
    }

    // mark trigger as used
    this.store.dispatch('chatbotStore/activateTrigger', id);

    const conversation = this.store.getters['chatbotStore/getConversation'](conversationId);

    if (conversation) {
      const isReady = this.store.getters['chatbotStore/isReady'];
      const currentConversationId = this.store.getters['chatbotStore/currentConversationId'];
      const latestConversationId = this.store.getters['chatbotStore/getLatestConversationId'];

      if (conversationId === currentConversationId && !isReady) {
        return;
      }

      if (isReady && !(compactNudge && !this.store.getters['chatbotStore/getOpenState'])) {
        const currentAmpId = this.store.getters['chatbotStore/currentAmpId'];

        if (currentAmpId !== conversation.ampId) {
          this.store.dispatch('chatbotStore/setAmpSetupOptions', {
            conversationId: conversation.id,
            ampId: conversation.ampId,
          });
          this.store.dispatch('chatbotStore/goToAmp', conversation.ampId);
        } else {
          this.store.dispatch('chatbotStore/setOpenState', true);
          this.store.dispatch('chatbotStore/setupConversation', conversation);

          const node = this.store.getters['chatbotStore/nextNode']();

          if (node) {
            this.nodeService.runNode(node);
          }
        }

        const nodeStack = this.store.getters['chatbotStore/currentStack'];

        this.tracking.sendResponseEvent('conversationChange', {
          conversationId: conversation.id,
          prevConversationId: nodeStack.length && latestConversationId ? latestConversationId : '',
          changeEvent: 'TRIGGER',
        });

        return;
      }

      this.store.dispatch('chatbotStore/setTriggeredConversation', { ...conversation, compactNudgeMessage });
      this.store.dispatch('chatbotStore/setNudgeState', true);
      if (!this.store.state.chatbotStore.isOpen) {
        this.store.dispatch('chatbotStore/setCompactNudgeVisible', compactNudge);
      }
    }
  }
}
